import { useNavigate } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  F0AvatarIcon,
  F0Button,
  F0Icon,
  F0TagRaw,
  F0TagStatus,
  IconType,
} from '@factorialco/f0-react'
import { Ai, Pig } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

type Props = {
  title: string
  description: string
  icon: IconType
  isHeaderCard: boolean
  slug: string
}

const Card = ({ title, description, icon, isHeaderCard, slug }: Props) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(
      `${navigation.discover.marketplaceModules.item.fullPath({
        id: slug,
      })}?upsell_origin=black_friday_promo`
    )
  }

  return (
    <Box
      background="white"
      borderRadius={{ all: 'abs016' }}
      style={{ minWidth: '334px', width: '334px' }}
      onClick={handleClick}
    >
      <Box padding="s16" gap="s12" style={{ flex: '1' }}>
        <F0AvatarIcon icon={icon} />
        <Box gap="s2">
          <Text.Normal color="grey1000" weight="semibold">
            {title}
          </Text.Normal>
          <Box
            style={{
              height: '80px',
              overflowY: 'auto',
            }}
          >
            <Text.Normal color="grey800">{description}</Text.Normal>
          </Box>
        </Box>
        <Box gap="s6">
          <Box flexDirection="row" gap="s4" style={{ width: 'fit-content' }}>
            <F0Icon icon={Ai} size="md" color="grey600" />
            <F0TagRaw
              text={i18n.t('marketplace.black_friday_promo.marketplace_list.card_tags.includes')}
            />
          </Box>
          <Box flexDirection="row" gap="s4" style={{ width: 'fit-content' }}>
            <F0Icon icon={Pig} size="md" color="grey600" />
            <F0TagStatus
              text={i18n.t('marketplace.black_friday_promo.marketplace_list.card_tags.discount')}
              variant="warning"
            />
          </Box>
        </Box>
      </Box>
      {isHeaderCard && (
        <Box
          paddingX="s16"
          paddingY="s12"
          flexDirection="row"
          gap="s4"
          justifyContent="spaceBetween"
          border={{ top: { style: 'solid', width: 's1', color: 'grey200' } }}
        >
          <F0Button
            label={i18n.t('upselling_kit.button.learn_more')}
            variant="outline"
            onClick={handleClick}
          />
          <F0Button
            label={i18n.t('marketplace.revamp.get_it_now')}
            variant="default"
            onClick={handleClick}
          />
        </Box>
      )}
    </Box>
  )
}

export default Card
